import { graphHooks } from '@tunasong/graph-lib/react'
import type { EdgeType } from '@tunasong/schemas'
import type { FC } from 'react'
import { EntityLink } from '../entity/entity-link.js'
import EmptyLinks from './empty-links.js'
import { LinearProgress } from '../primitives/index.js'
import styles from './edges.module.css'

export interface LinksProps {
  sourceId?: string
  targetId?: string
}

const emojis: Record<EdgeType, string> = {
  embeds: '📎',
  follows: '👣',
  likes: '👍',
  isRelatedTo: '🔗',
  // hasRecording is the same as isPerformanceOf, except that it is a relation from the recording to the performance
  hasRecording: '🎙️',
  linksTo: '🔗',
  isParentOf: '👶',
  mentions: '💬',
  comments: '💬',
  includes: '📦',
  calendar: '📅',
  member: '👥',
  hasImage: '🖼️',
}

const internalTargets = ['assistant']

export const Edges: FC<LinksProps> = ({ sourceId = '', targetId }) => {
  const { entity: source } = graphHooks.useEntity(sourceId)
  const { edges: rawLinks = [], isLoading } = graphHooks.useEdges({ sourceId, targetId })
  /** Filter away isParentOf the relation, and internal targets */
  const links = rawLinks.filter(link => link.relation !== 'isParentOf' && !internalTargets.includes(link.target))

  const ids = links
    .flatMap(backlink => [backlink.target, backlink.context?.id])
    .filter(id => id !== 'ROOT')
    .filter(Boolean)

  const { entities = [] } = graphHooks.useEntitiesById(ids)

  return (
    <div>
      {isLoading ? <LinearProgress /> : null}
      {links.map((link, idx) => {
        const target = entities.find(e => e.id === link.target)
        const context = entities.find(e => e.id === link.context?.id)
        const titletext = link.relation + (context ? ` in ${context.name}` : '')

        return target ? (
          <div key={idx} className={styles.edgeRow}>
            {source ? <EntityLink entity={source} /> : null}
            <div className={styles.emojiContainer}>
              <div title={titletext} className={styles.emoji}>
                {' '}
                {emojis[link.relation as EdgeType]}{' '}
              </div>
            </div>
            <EntityLink entity={target} />
          </div>
        ) : null
      })}
      {links.length === 0 ? <EmptyLinks /> : null}
    </div>
  )
}

export default Edges
